import { FC } from 'react'

import { cn } from 'src/lib/cn'
import HtmlProps from 'src/types/HtmlProps'

export interface BadgeAddOnProps extends HtmlProps<HTMLDivElement> {
  label?: string
}

const BadgeAddOn: FC<BadgeAddOnProps> = ({ label, className, ...divProps }) => {
  return (
    <div
      data-testid="badge-add-on"
      className={cn(
        'bg-fog text-bay-of-many radius-[2px] items-center px-[2px] text-[10px] font-bold',
        className,
      )}
      {...divProps}
    >
      {label || 'Add-on'}
    </div>
  )
}

export default BadgeAddOn
